<template>
	<ProjectMenuTabsExplanation @dismiss="onDismiss" v-if="!useDismissedPlacementTabExplanation">
		<h5>Placements lets you create and manage features based on where they are used</h5>
	</ProjectMenuTabsExplanation>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { useDismissedPlacementTabExplanation } from '@/store/modules/appLayout/getters.js';
import { setDismissedPlacementTabExplanation } from '@/store/modules/appLayout/actions.js';
import ProjectMenuTabsExplanation from '@/components/ProjectMenu/ProjectMenuTabsExplanation.vue';
export default {
	name: 'PlacementTabExplanation',
	components: { ProjectMenuTabsExplanation },
	computed: {
		...mapGettersShorthand({ useDismissedPlacementTabExplanation }),
	},
	methods: {
		...mapActionsShorthand({ setDismissedPlacementTabExplanation }),
		onDismiss() {
			this.setDismissedPlacementTabExplanation({ dismissed: true });
		},
	},
};
</script>

<style scoped lang="scss"></style>
